import React from 'react';
import ApprovalRequestCard from '../approvals/ApprovalRequestCard';
import { useAuth } from '../../contexts/AuthContext';

/**
 * One of the employee's own time off requests (or, for an admin, anyone's).
 *
 * The card itself is the one the approvals queue uses, so a request looks the
 * same to the person who filed it and the person deciding it. What differs is
 * the buttons: this side gets edit and withdraw rather than review.
 */
export default function TimeOffRequestCard({ request, onClick, onWithdraw, onEdit }) {
  const auth = useAuth();

  if (!request) return null;

  const status = String(request.status || '').toLowerCase();
  const isPending = status === 'pending';
  const isApproved = status === 'approved';
  const isOwner = Boolean(auth.employee?.id)
    && String(request.employee_id) === String(auth.employee.id);

  // Withdrawing an approved request is a deletion — the hours are already on the
  // calendar and the PTO balance — so it is named for what it does.
  const canWithdraw = (isPending || isApproved) && isOwner && typeof onWithdraw === 'function';
  // An admin can also edit anyone's request, approved ones included; the owner
  // is emailed what changed (see PUT /time-off/:id).
  const canEdit = typeof onEdit === 'function'
    && ((isPending && isOwner) || (auth.isAdmin() && (isPending || isApproved)));

  const actions = [];
  if (canEdit) {
    actions.push({ key: 'edit', label: 'Edit', onClick: onEdit });
  }
  if (canWithdraw) {
    actions.push({
      key: 'withdraw',
      label: isApproved ? 'Delete' : 'Withdraw',
      color: 'red',
      onClick: onWithdraw,
    });
  }

  return (
    <ApprovalRequestCard
      kind="timeoff"
      record={request}
      onReview={onClick}
      primaryLabel="View"
      showStatus
      actions={actions}
    />
  );
}
